module.exports = __webpack_public_path__ + "img/model_63_ug.91f78f70.jpg";